<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <link
      href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@600;900&display=swap"
      rel="stylesheet"
    />
    <title>Document</title>
  </head>

  <body>
    <div class="container">
      <div class="err">4</div>
      <i class="bi bi-question-circle"></i>
      <div class="err2">4</div>
      <div class="msg">
        La page que vous recherchez a peut-être bougée ? A été supprimée ? Se
        cache ? N'a jamais existée ?
        <p>Retour à l' <a href="/accueil">accueil</a></p>
      </div>
    </div>
  </body>
</html>
